<template>
    <div class="wrap">
        <p></p>
        <div class="report">
            <div class="info">
                <div class="top-dashboard">
                    <h3 style="font-family: poppins-bold;">Kinerja Semua Petugas</h3>
                    <div class="wrap-tgl">
                        <div class="tgl">
                            <label for="">Dari Tanggal</label>
                            <input type="date" name="" id="" v-model="tgl_awal">
                        </div>
                        <div class="tgl">
                            <label for="">Sampai Tanggal</label>
                            <input type="date" name="" id="" v-model="tgl_akhir">
                        </div>
                        <button @click="ubahTgl()">ubah tanggal</button>
                    </div>

                </div>
                <div class="w-info">
                    <div class="info-item totalPetugas">
                        <p>Total Petugas</p>
                        <h2 v-if="rawData">{{ rawData.total_petugas + 1 }}</h2>
                    </div>
                    <div class="info-item rataTiket">
                        <p>Rata-Rata Tiket</p>
                        <h2 v-if="rawData">{{ rawData.rata_rata_tiket }}</h2>
                    </div>
                    <div class="info-item rataRespon">
                        <p>Rata-Rata Respon</p>
                        <h2 v-if="rawData">{{ rawData.rata_rata_respon }}</h2>
                    </div>
                    <div class="info-item totalRespon">
                        <p>Total Respon</p>
                        <h2 v-if="rawData">{{ rawData.total_respon }}</h2>
                    </div>
                </div>
            </div>

            <div class="tb">
                <table cellspacing="0">
                    <thead>
                        <tr>
                            <th>No</th>
                            <th>Nama Petugas</th>
                            <th>Username</th>
                            <th>Close Tiket</th>
                            <th>Response Rate</th>
                            <th>Terakhir Aktif</th>
                            <th>Aksi</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(n, index) in dataPetugas" :key="index">
                            <td style="text-align: center;">{{ index + 1 }}</td>
                            <td>{{ n.nama_petugas }}</td>
                            <td>{{ n.username }}</td>
                            <td style="text-align: center;">{{ n.close_tiket }}</td>
                            <td style="text-align: center;">{{ n.response_rate }}</td>
                            <td>{{ n.terakhir_aktif }}</td>
                            <td class="action-cell" style="text-align: center;">
                                <button class="btn-edit" @click="toggleAksi(n)">
                                    <i class="fas fa-ellipsis-vertical"></i>
                                </button>

                                <div class="container-aksi" v-if="activeAksi === n">
                                    <div class="item-aksi">
                                        <i class="fal fa-pen-to-square"></i>
                                        <p><small>Edit data petugas</small></p>
                                    </div>
                                    <div class="item-aksi">
                                        <i class="fal fa-trash"></i>
                                        <p><small>Hapus petugas</small></p>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<style scoped>
.wrap {
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: grid;
    grid-template-rows: max-content auto;
    padding: 0px;
    box-sizing: border-box;
    background-color: #f2f2f2;

    .report {
        height: 100%;
        width: 100%;
        overflow: hidden;
        border-radius: 0px;
        display: grid;
        grid-template-rows: max-content auto;

        .info {
            width: 100%;
            padding: 20px;
            box-sizing: border-box;
            background-color: white;

            .top-dashboard {
                display: grid;
                grid-template-columns: auto max-content;

                select {
                    margin-left: 20px;
                    outline: none;
                    padding: 3px 10px;
                    font-family: poppins-reg;
                    border: 2px solid #b9d1ff;
                    background-color: #ebf2ffc4;
                    border-radius: 5px;
                }

                .wrap-tgl {
                    display: grid;
                    grid-template-columns: repeat(3, max-content);
                    gap: 20px;

                    label {
                        margin-right: 5px;
                        font-size: 10pt;
                    }

                    input {
                        padding: 9px 10px;
                        background-color: #f2f2f2;
                        border-radius: 5px;
                        border: 1px solid #f2f2f2;
                        cursor: pointer;
                    }

                    button {
                        padding: 3px 10px;
                        border: none;
                        background-color: #1869ff;
                        color: white;
                        border-radius: 5px;
                        font-family: poppins-reg;
                        cursor: pointer;
                    }
                }
            }

            .w-info {

                height: min-content;
                display: grid;
                grid-template-columns: repeat(4, auto);
                grid-gap: 20px;
                background-color: transparent;
                margin-top: 20px;

            }

            .info-item {
                border-left: 5px solid #1869ff;
                background-color: #ebf2ffc4;
                width: 100%;
                height: max-content;
                padding: 15px 20px;
                box-sizing: border-box;

                h2 {
                    font-size: 30pt;
                    text-align: center;
                }

            }
        }

        .tb {
            height: 100%;
            padding: 0px 20px;
            box-sizing: border-box;
            width: 100%;
            background-color: white;

            table {
                background-color: white;
                width: 100%;
                border-radius: 15px;
                border: 1px solid #f2f2f2;
                height: max-content;
                border-collapse: collapse;

                th {
                    font-family: poppins-semi;
                }

                th,
                td {
                    font-size: 10pt;
                    padding: 15px 5px;
                }

                td {
                    border-top: 1px solid #f2f2f2;
                }

                th {
                    background-color: #ebebebc4;
                }

                button {
                    font-size: 12pt;
                    padding: 3px 5px;
                    cursor: pointer;
                    background-color: white;
                    border: none;
                }

                /* pastikan sel tempat tombol jadi posisi referensi */
                td.action-cell {
                    position: relative;
                }
            }

            .container-aksi {
                position: absolute;
                /* ubah dari fixed ke absolute */
                top: 100%;
                /* tampil tepat di bawah tombol */
                right: 0;
                background-color: white;
                border: 1px solid #ddd;
                border-radius: 10px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
                width: 180px;
                z-index: 10;
                padding: 8px;
            }

            .container-aksi .item-aksi {
                display: flex;
                align-items: center;
                gap: 8px;
                padding: 6px;
                border-radius: 6px;
                cursor: pointer;
            }

            .container-aksi .item-aksi:hover {
                background-color: #f7f7f7;
            }
        }

    }
}
</style>

<script>
import axios from "axios"
import { backend as be } from "@/assets/config/server.js"
import { getCookie } from "@/assets/config/cookie";

export default {
    name: "DashboardReport",
    components: {

    },
    data() {
        return {
            show: true,
            activeAksi: null,
            rawData: null,
            dataPetugas: null,
            perbulan: true,
            tgl_awal: null,
            tgl_akhir: null,
            loginInfo : null
        }
    },
    updated() {

    },
    mounted() {
        const date = new Date();

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        this.tgl_awal = `${year}-${month}-01`;
        this.tgl_akhir = `${year}-${month}-${day}`;

        this.getApi(
            `api/kinerja-petugas?tanggal_awal=${this.tgl_awal}&tanggal_akhir=${this.tgl_akhir}`
        );
    },

    // computed: {
    //     currentFirst() {
    //         return this.toDDMMYYYY(this.tgl_awal);
    //     },
    //     currentLast() {
    //         return this.toDDMMYYYY(this.tgl_akhir);
    //     }
    // },
    computed: {
        currentFirst() {
            return this.tgl_awal;   // ✅ 2026-01-01
        },
        currentLast() {
            return this.tgl_akhir;  // ✅ 2026-01-30
        }
    }
    ,
    methods: {
        toDDMMYYYY(dateStr) {
            if (!dateStr) return "";
            if (!dateStr.includes("-")) return dateStr;

            const [y, m, d] = dateStr.split("-");
            return `${d}/${m}/${y}`;
        },
        toggleAksi(n) {
            this.activeAksi = this.activeAksi === n ? null : n
        },
        ubahTgl() {
            const hitapi = this.getApi(
                `api/kinerja-petugas?tanggal_awal=${this.tgl_awal}&tanggal_akhir=${this.tgl_akhir}`
            );

            console.log(hitapi)
        },

        async getApi(api) {
            this.loginInfo = JSON.parse(getCookie('loginInfo'))
            const sessionToken = this.loginInfo.token;
            try {
                const res = await axios.get(
                    `${be}/${api}`,
                    {
                        headers: {
                            Accept: "application/json",
                            Authorization: `Bearer ${sessionToken}`,
                        },
                    }
                );

                this.rawData = res.data
                this.dataPetugas = this.rawData.data
            } catch (err) {
                console.error(err)
            }
        },
    }
}
</script>